export {default as flextree} from './src/flextree';
